module.exports = __webpack_public_path__ + "@/assets/img/layout-grid.75b10ada.svg";